import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material-components.module';
import { LoadingOverlayComponent } from './loading-overlay.component';
import { OtpInputComponent } from '../otp-input/otp-input.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  declarations: [LoadingOverlayComponent, OtpInputComponent],
  exports: [LoadingOverlayComponent, OtpInputComponent]
})
export class LoadingOverlayModule {
}
